import script from "./UiAuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./UiAuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./UiAuthLayout.vue?vue&type=style&index=0&id=a1af0760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1af0760"]])

export default __exports__